import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Blocks protected Shipment Creation routes until Okta authentication succeeds.
 */
export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  return auth.ensureAuthenticatedForNavigation();
};
